<template>
  <v-row justify="center">
    <v-dialog v-model="IsMCPVisible" max-width="800px">
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on"> Nouveau projet </v-btn>
      </template>
      <v-card color="#f0f0f0">
        <v-card-title>
          <span class="text-h5">Création d'un nouveau projet</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-row>
                <v-col cols="5">
                  <v-text-field
                    color="#51bdcb"
                    label="Nom du projet"
                    required
                    class="field"
                    v-model="name"
                    :rules="nameRules"
                  ></v-text-field>
                </v-col>
                <v-col cols="2">
                  <v-select
                    :items="activities"
                    v-model="activity"
                    name="Activity"
                    label="Pôle"
                    color="#51bdcb"
                    item-color="dark"
                    :rules="[(v) => !!v || 'Un pôle doit être sélectionné']"
                  >
                  </v-select>
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    type="number"
                    rows="1"
                    color="#51bdcb"
                    label="Budget simulé"
                    required
                    class="field"
                    v-model="budget"
                    min="0"
                    :rules="budgetRules"
                  ></v-text-field>
                </v-col>
                <v-col cols="1">
                  <v-tooltip right max-width="300">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" class="mt-3">
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <span>
                      Le budget renseigné ne sera pris en compte que s'il s'agit
                      d'un projet simulé qui n'existe pas sur BoondManager,
                      sinon les données de Boond écraserons le budget entré.
                    </span>
                  </v-tooltip>
                </v-col>
              </v-row>
              <v-col cols="12" sm="6">
                <vc-date-picker
                  show-iso-weeknumbers="left-outside"
                  v-model="dates"
                  :available-dates="{ start: new Date(), end: null }"
                  mode="date"
                  is-range
                  color="gray"
                  class="mx-7"
                >
                </vc-date-picker>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="dateRangeStart"
                  label="Nouveau premier jour"
                  prepend-icon="mdi-calendar"
                  readonly
                  color="#51bdcb"
                ></v-text-field>
                <v-text-field
                  v-model="dateRangeEnd"
                  label="Nouveau dernier jour"
                  prepend-icon="mdi-calendar"
                  readonly
                  color="#51bdcb"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" v-if="blankError">
                <v-alert
                  border="right"
                  colored-border
                  type="error"
                  elevation="2"
                >
                  Veuillez remplir tous les champs s'il vous plaît
                </v-alert>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#51bdcb" text @click="closeMCP"> Annuler </v-btn>
          <v-btn color="#51bdcb" text @click="addProject"> Créer </v-btn>
        </v-card-actions>
      </v-card>
      <template v-if="isErrorMessageDisplayed"><PopUpError /></template>
    </v-dialog>
  </v-row>
</template>

<script>
import { ADD_PROJECT } from '../graphql/GraphQLMutations';
import { GET_ALL_PROJECTS } from '../graphql/GraphQLQueries';
import PopUpError from './PopUpError.vue';

export default {
  name: 'ModalCreateProject',

  components: {
    PopUpError,
  },

  data: () => ({
    boondExist: false,
    IsMCPVisible: false,
    blankError: false,
    name: '',
    budget: 50,
    activity: '',
    activities: ['BI', 'ERP', 'Web'],
    nameRules: [
      (v) => !!v || 'Le nom doit être rempli',
      (v) => v.length >= 2 || 'Le nom doit contenir au moins 2 caractères',
    ],
    budgetRules: [
      (v) => !!v || 'Le budget doit être rempli',
      (v) =>
        /^\d*[1-9]\d*$/.test(v) ||
        'Le budget doit être positif et différent de 0',
    ],
    dates: {
      start: new Date(),
      end: new Date(),
    },
    reg: /^\d*[1-9]\d*$/,
    isErrorMessageDisplayed: false,
  }),

  methods: {
    closeMCP() {
      this.blankError = false;
      this.IsMCPVisible = false;
    },
    addProject() {
      this.isErrorMessageDisplayed = false;
      const { name } = this;
      const budget = parseInt(this.budget, 10);
      const { activity } = this;
      const startDate = this.dateRangeStart;
      const endDate = this.dateRangeEnd;

      if (name.length >= 2 && this.reg.test(budget) && activity) {
        const input = {
          name,
          budget,
          activity,
          startDate,
          endDate,
        };

        this.$apollo
          .mutate({
            mutation: ADD_PROJECT,
            variables: {
              input,
            },
            update: (cache, { data: { addProject } }) => {
              const data = cache.readQuery({ query: GET_ALL_PROJECTS });
              data.getAllProjects.push(addProject);
              cache.writeQuery({ query: GET_ALL_PROJECTS, data });
            },
          })
          .then(() => {
            this.IsMCPVisible = false;
          })
          .catch(() => {
            this.isErrorMessageDisplayed = true;
          });
      } else {
        this.blankError = true;
      }
    },
  },

  computed: {
    dateRangeStart() {
      const dateStart = this.dates.start.toISOString().slice(0, 10);
      return dateStart;
    },
    dateRangeEnd() {
      const dateEnd = this.dates.end.toISOString().slice(0, 10);
      return dateEnd;
    },
  },
};
</script>
